import React, { useState, useRef, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CalculateIcon from '@mui/icons-material/Calculate';
import SellIcon from '@mui/icons-material/Sell';
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import ValueModelCreateForm from "./ValueModelCreateForm";
import ValueModelsList from "./ValueModelsList";
import ModalElement from "../Modal";
import ProgressStepper from "../ProgressStepper";
import ViewValueModel from "./ViewValueModel";

import { addValueModel, fetchValueModels, clearCostValueDriver, fetchValueModel } from "../../actions/valueActions";
import { fetchProducts } from "../../actions/productActions";
import history from "../../history";

const ValueModels = () => {
    const formikRef = useRef(null);
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    const [valueModelCreateOpen, setValueModelCreateOpen] = useState(false)
    const [valueModelModalOpen, setValueModelModalOpen] = useState(false)
    const [previewValueModelId, setPreviewValueModelId] = useState(false)

    // Access state for valueModels
    const id = searchParams.get('id')
    const allValueModels = useSelector(state => state.value.valueModels)
    const products = useSelector(state => state.product.products)
    const valueModels = allValueModels.filter(model => model.product.id === parseInt(id));
    const product = Object.values(products).find(product => product.id === parseInt(id));

    useEffect(() => {
        dispatch(fetchValueModels())
        dispatch(fetchProducts())

        return () => {
            // This is the cleanup function
            dispatch(clearCostValueDriver())
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps        
    }, [])

    const toggleValueModelCreateOpen = () => {
        setValueModelCreateOpen(!valueModelCreateOpen)
    }

    const handleClose = () => {
        setValueModelCreateOpen(false)
        setValueModelModalOpen(false)
    }

    const previewValueModel = async (id) => {
        await dispatch(fetchValueModel(id))
        setPreviewValueModelId(id)
        setValueModelModalOpen(true)
    }

    const valueModelOnSubmit = async (values) => {
        values.code = values.industry.code
        values.industry = values.industry.industry
        // values.product = Object.values(products).find(product => product.name === values.product);
        values.product = product

        await dispatch(addValueModel(values))
        handleClose()
        if (formikRef.current) {
            formikRef.current.resetForm();
        }

    }

    const valueModelFormActions = () => {
        return (
            <Button type="submit" variant="contained" sx={{ flexGrow: 1 }}>Create</Button>
        )
    }

    function renderCreateValueModelModal() {
        return (
            <ModalElement
                modalOpen={valueModelCreateOpen}
                // modalWidth={600}
                handleClose={handleClose}
                header="Create Value Model"
                instruction="Choose a Name and Industry"
                content={
                    <ValueModelCreateForm
                        products={products}
                        formActions={valueModelFormActions}
                        onSubmit={valueModelOnSubmit}
                    />
                }
            />
        )
    }

    function createNewAction() {
        return (
            <Button variant="contained" onClick={toggleValueModelCreateOpen} disabled={!product} sx={{ textTransform: 'none' }}>Create Value Model</Button>
        )
    }

    function renderValueModelModal() {
        return (
            <ModalElement
                modalOpen={valueModelModalOpen}
                modalWidth={1400}
                handleClose={handleClose}
                header="Preview Value Model"
                instruction="The Price Range between the Price of Alternative and Your Created Value is where you should keep your price, if Your Created Value is higher. Your Created Value is always the maximum you can charge and you should probably set your price in the lower end of the range."
                content={
                    <ViewValueModel
                        id={previewValueModelId}
                    />
                }
            />
        )
    }

    return (
        <Box>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Stack direction="row" alignItems="center" gap={1} sx={{ ml: 5, mt: 3 }}>
                    <CalculateIcon />
                    <Typography variant='h6'>
                        Value Models
                    </Typography>
                </Stack>
                {/* <Button variant="contained" onClick={toggleValueModelCreateOpen} sx={{ mr: '30%', mt: 3 }}>
                    Create Value Model
                </Button> */}
                <Button variant="contained" startIcon={<ArrowBackIosIcon />} onClick={() => history.push('/')} sx={{ mr: '30%', mt: 3, textTransform: 'none' }}>
                    Back
                </Button>                
            </Stack>
            <Box>
                <Stack direction="row" alignItems="center" gap={1} sx={{ ml: 5, mt: 3, display: 'inline-flex', border: '1px solid #ccc', borderRadius: '8px', padding: 2, }}>
                    <SellIcon sx={{ fontSize: '1rem' }} />
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                        Product:
                    </Typography>
                    <Typography variant="body2">
                        {!product ? 'No Product' : product.name}
                    </Typography>
                </Stack>
            </Box>
            <ProgressStepper activeStep={1} />
            <ValueModelsList
                valueModels={valueModels}
                createNew={createNewAction}
                preview={(id) => previewValueModel(id)}
            />

            {renderCreateValueModelModal()}
            {renderValueModelModal()}
        </Box>
    )
}

export default ValueModels